import { useWindowDimensions } from "../../../../hooks/useDimensionHook";
import { Button } from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";
import { useState } from "react";
import { downloadFile } from "./../../../../API/API";
import { alertNotification } from "../../../../components/TopNotification/alertNotification";
import { getTimeZone } from "../../../../shared/helpers";

const TimeSheetDownloadButton = ({ dateRange, timesheetId }) => {
  const { width } = useWindowDimensions();
  const [loading, setLoading] = useState(false);
  const handleDownload = async (e) => {
    try {
      e?.preventDefault();
      setLoading(true);
      await downloadFile({
        timesheetId: timesheetId,
        startDate: dateRange?.[0]?.format("YYYY-MM-DD"),
        endDate: dateRange?.[1]?.format("YYYY-MM-DD"),
        timeZone:getTimeZone()
      });
    } catch (error) {
      alertNotification(
        "error",
        error.response.data.errorMessage ||
          error?.message ||
          error ||
          "Something went wrong."
      );
    } finally {
      setLoading(false);
    }
  };
  if (width > 768)
    return (
      <Button
        loading={loading}
        type="primary"
        icon={<CloudDownloadOutlined />}
        onClick={handleDownload}
      >
        Download Report
      </Button>
    );
  else
    return (
      <Button loading={loading} type="primary" onClick={handleDownload}>
        <CloudDownloadOutlined />
      </Button>
    );
};

export { TimeSheetDownloadButton };
